module.exports.main = `
  INSERT INTO fin.account (
     origin, company, account_id,
     parent_id, active, name, fullname, num,
     classification, account_type, account_subtype,
     balance, currency
  )
  SELECT origin
       , company
       , account_id
       , (data->'ParentRef'->>'value')::INTEGER as parent_id
       , (data->>'Active')::BOOLEAN as active
       , (data->>'Name') as name
       , (data->>'FullyQualifiedName') as fullname
       , (data->>'AcctNum') as num
       , (data->>'Classification') as classification
       , (data->>'AccountType') as account_type
       , (data->>'AccountSubType') as account_subtype
       , (data->>'CurrentBalance')::NUMERIC as balance
       , (data->'CurrencyRef'->>'value')::fin.currency_type as currency
  FROM raw
`
